import { Box, Link, Flex, FlexItem } from '@gusto/workbench';
import { ExternalLink } from '@gusto/workbench-icons';
import KaleHeadset from '../../../../../../images/signupV2/illo-headset-kale.svg';

const EVENT_NAME = 'ScheduleACall';

const track = (event: string) =>
  GustoAnalytics.track({
    eventCategory: EVENT_NAME,
    eventName: event,
    data: {
      location: 'SIGNUP',
    },
  });

const ScheduleACallPanel = () => {
  return (
    <Box
      paddingHorizontal={6}
      paddingVertical={4}
      borderRadius={8}
      className="border-none bg-kale-100 schedule-a-call-panel"
    >
      <Flex columnGap={4}>
        <FlexItem className="d-none d-md-flex" justifyContent="center" alignSelf="center">
          <img src={KaleHeadset} className="img-width-50px" alt="" width={50} height={50} />
        </FlexItem>
        <FlexItem>
          <Box component="p" className="text-large-bold">
            Questions about payroll, benefits and more? Our team is here to help.
          </Box>
          <Link
            target="_blank"
            rel="noopener"
            href="https://gusto.chilipiper.com/router/schedule-a-call-mdr"
            after={<ExternalLink title="Opens in a new tab" />}
            onClick={() => track('ScheduleTimeLinkClicked25Plus')}
          >
            Schedule a time to talk
          </Link>
        </FlexItem>
      </Flex>
    </Box>
  );
};

export default ScheduleACallPanel;
